import { render } from "./MarkAsActiveInactiveModal.html?vue&type=template&id=ff1c521c&scoped=true"
import script from "./MarkAsActiveInactiveModal.js?vue&type=script&lang=js"
export * from "./MarkAsActiveInactiveModal.js?vue&type=script&lang=js"

import "./MarkAsActiveInactiveModal.css?vue&type=style&index=0&id=ff1c521c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1c521c"]])

export default __exports__